import type { LeadFormType } from "./types";

import { LEAD_FORM_CONTRACTS } from "./form-contracts";

/**
 * Contract fields that carry no personal data and may be persisted: the query
 * prefill allowlist plus the office selection the postal code resolves to.
 * Callers must treat every field outside this set as personal, so a field
 * added to the contract later stays out of storage until it is listed here
 * explicitly. Which fields may be read from the URL is a narrower question,
 * answered by `queryPrefillParameters` alone.
 */
function getPersistableFieldNames(formType: LeadFormType): ReadonlySet<string> {
  const contract = LEAD_FORM_CONTRACTS[formType];

  return new Set([
    ...Object.keys(contract.queryPrefillParameters),
    ...contract.officeSelectionFieldNames,
  ]);
}

export { getPersistableFieldNames };
